export function getJobsPortalItemBadge(itemId, menuBadges = {}) {
    switch (itemId) {
        case 'tasks-assigned':
            return menuBadges.employeePending || 0;
        case 'tasks-company':
        case 'create-task':
            return menuBadges.companyApprovals || 0;
        case 'tasks-disputed':
            return menuBadges.workspace || 0;
        default:
            return 0;
    }
}
